
(function() {
  'use strict';

    var ftcFieldInteractions = function (ajaxCall, $timeout, $filter) {
       return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

                $scope.fnChangeFtcEndDate = function(){
                    var ajaxUrl = WEBAPP_PATH + "/item/updateFtcEndDate?ftcDuration="+$scope.$parent.formModel.ftcDurtionTypeLookupVal.id+"&startDate="+$filter('date')($scope.$parent.formModel.startDate, "yyyy-MM-dd");
                    ajaxCall.getData(ajaxUrl).then(
                        function(result) {
                            if (result.data.success) {
                                $scope.$parent.formModel.ftcEndDate = new Date(result.data.ftcEndDate);
                                $scope.$parent.formModel.proRatedCharge = result.data.proRatedCharge
                            }

                        },
                        function(result) {
                    });
                }
            }]
        };
    }

    ftcFieldInteractions.$inject = ['ajaxCall', '$timeout', '$filter'];
    angular.module('app').directive('ftcFieldInteractions', ftcFieldInteractions);
}());
